import React from "react"
import PropTypes from "prop-types"

import styles from "./styles.css"

const Table = ({ children, ...props }) => {
  return (
    <table {...props} className={styles.table}>
      {children}
    </table>
  )
}

Table.propTypes = {
  children: PropTypes.node
}
export default Table



// WEBPACK FOOTER //
// ./src/components/Table/index.js